<template>
  <div class="pa-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
      <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
        <span>{{message}}</span>
      </v-snackbar>
      <v-card class="neu-glow pb-3">
        <v-card-title primary-title>
          <div class="text-h5">Periodi Chiusura</div>
          <v-spacer></v-spacer>
          <v-div>
            <!--
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :disabled="closedPeriods_hash==JSON.stringify(closedPeriods)" :loading="loading_update"  @click.stop="saveItems()">
                  <v-icon color="error">mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
            -->             
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click.stop="editItem(null)">
                  <v-icon color="info">mdi-plus-circle</v-icon>
                </v-btn>
              </template>
              <span>Aggiungi</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>                           
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading"  @click.stop="getData('refresh')">
                  <v-icon color="info">mdi-sync-circle</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-div>           
        </v-card-title>
        <div class="mx-4">
          <v-data-table
            dense
            fixed-header
            :headers="headers_closedPeriods"
            :items="!closedPeriods?[]:closedPeriods"
            hide-default-footer
            :items-per-page=500
            item-class="row-height-36"
            :loading="loading||loading_refresh"		   
            no-data-text="Nessun dato presente in archivio"
            no-results-text="Nessun Risultato estratto"
            loading-text="Consultazione archivio: attendi..."
          >

            <template v-slot:[`item.from`]="{ item }">
              <div>
                {{new Intl.DateTimeFormat(settings.options.language, { day:'2-digit',month:'2-digit',year:'numeric' }).format(new Date(item.from))}}
              </div>
            </template>

            <template v-slot:[`item.to`]="{ item }">
              <div>
                {{new Intl.DateTimeFormat(settings.options.language, { day:'2-digit',month:'2-digit',year:'numeric' }).format(new Date(item.to))}}
              </div>
            </template>
                      
            <template v-slot:[`item.active`]="{ item }">
              <v-simple-checkbox
                v-model="item.active"
                color="info"
                style="pointer-events: none"
              ></v-simple-checkbox>
            </template>

            <template v-slot:[`item.lunch`]="{ item }">
              <v-simple-checkbox
                v-model="item.lunch"
                color="info"
                style="pointer-events: none"
              ></v-simple-checkbox>
            </template>

            <template v-slot:[`item.dinner`]="{ item }">
              <v-simple-checkbox
                v-model="item.dinner"
                color="info"
                style="pointer-events: none"
              ></v-simple-checkbox>
            </template>                        

            <template v-slot:[`item.htmlMessage`]="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on"  color="info">mdi-message-bulleted</v-icon>
                </template>
                <span v-html="item.htmlMessage"></span>
              </v-tooltip>
            </template>            

            <template v-slot:[`item.actions`]="{ item }">
              <!--
              <v-icon
                color="warning"
                class="mr-2"
                @click="editItem(item)"
                >
                mdi-pencil
              </v-icon>    
              -->          
              <v-icon
                color="error"
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-form>
    <v-dialog v-model="dialog_edit" 
        max-width="600"
        v-if="dialog_edit"
      >
        <v-card class="neu-glow">
          <v-card-title>
            Nuovo Periodo di Chiusura
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :disabled="!(editedItem.range&&(editedItem.lunch||editedItem.dinner))" :loading="loading_update" @click="saveItem()">
                      <v-icon color="error">mdi-content-save</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_edit = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>             
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row class="mt-3 neu-glow ma-4 pa-2">
              <v-col cols="6"> 
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  color="info"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.range"
                      label="Periodo"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      color="info"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.range"
                    locale="it"
                    range
                  >
                    <v-spacer></v-spacer>
                    <v-btn icon small class="neu-glow mr-2"  @click="menu1 = false">
                        <v-icon color="info">mdi-thumb-up</v-icon>
                    </v-btn> 
                  </v-date-picker>
                </v-menu> 
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="editedItem.reason"
                  label="Motivo"
                  prepend-inner-icon="mdi-message-processing"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  color="info"
                  hint="Valore che verrà mostrato al cliente"
                ></v-text-field>              
              </v-col>              
              <!--
              <v-col cols="6"> 
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  color="info"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.from"
                      label="Dal"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      color="info"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.from"
                    locale="it"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu> 
              </v-col>
              
              <v-col cols="6"> 
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  color="info"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="editedItem.to"
                      label="Al"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      color="info"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.to"
                    locale="it"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu> 
              </v-col>
              -->
              <v-col cols="12" class="py-1">
                Chiuso a
              </v-col>
              <v-col cols="6" class="d-flex justify-center"> 
                <v-switch
                  inset
                  v-model="editedItem.lunch"
                  label="Pranzo"
                  color="info"
                ></v-switch>
              </v-col>
              <v-col cols="6" class="d-flex justify-center"> 
                <v-switch
                  inset
                  v-model="editedItem.dinner"
                  label="Cena"
                  color="info"
                ></v-switch>
              </v-col>              

              <!--
              <v-col cols="12">
                <div>Messaggio</div>
                <vue-editor v-model="editedItem.htmlMessage" :editorToolbar="customToolbar"   />
              </v-col>
              -->   
            </v-row>         
          </v-card-text>
          <!--
          <v-card-actions>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="dialog_edit = false" color="info" v-bind="attrs" v-on="on">
                  <v-icon class="mr-2">mdi-close-box</v-icon>
                  <span class="d-none d-md-block">Esci</span>
                </v-btn>
              </template>
              <span>Esci senza modificare</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="saveItem()" color="green" v-bind="attrs" v-on="on">
                  <v-icon class="mr-2">mdi-save</v-icon>
                  <span class="d-none d-md-block">Salva</span>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>
          </v-card-actions>-->
        </v-card>
    </v-dialog>    
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5">
                <v-col md="6" cols="12">
                    <p>
                        Ai fini di semplificare la gestione dell'attività è possibile suddividere l'attività sia in funzione dello spazio che del tempo per adattarla alle proprie necessità:
                    </p>
                    <p>
                      A livello spaziale, distinguiamo tra suddivisioni esplicite (Aree), che il cliente potrà selezionare, e suddivisioni implicite (Sale), che gestirà l'operatore:<br /><br />
                      come suddivisioni esplicite, "interno" ed "esterno" sono solitamente sufficienti, ma qualora vi sia una o più aree particolari è possibile aggiungerle.<br />
                      le suddivisioni implicite invece saranno le sale o porzioni di esse come da voi definite nel riquadro in basso:<br>es: "Sala1", "Sala2", etc. oppure "Sala Interna", "Sala Esterna"
                      una volta create le sale queste andranno "collegate" all'Area di competenza.
                    </p>
                </v-col>
                <v-col md="6" cols="12">
                    <p>
                      Per ogni Area è possibile definire giorno e mese sia di inizo che di fine Operatività: è importante definire questi parametri in quanto l'area sarà prenotabile da parte del cliente solo nel periodo in cui è operativa.
                    </p>                  
                    <p>
                      Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                    </p>
                    <p>
                      Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                    </p>
                </v-col>
                <v-col cols="12">
                    <p color="error">
                        <strong>Attenzione:</strong> Questi vingoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare qualsiasi prenotazione
                    </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>    
    <v-dialog v-model="dialog_delete" max-width="500px">
        <v-card>
            <v-card-title class="text-h5">Confermi Cancellazione?
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  @click="saveItem('delete')">
                      <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                  </template>
                  <span>Conferma</span>
              </v-tooltip>   

              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_delete=false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>                 
            </v-card-title>

        </v-card>
    </v-dialog>      
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import { VueEditor  } from "vue2-editor";
//import _ from 'lodash'

export default {
  //   components: { VueEditor },
  data() {
    return {
      page: "Account",
      form: null,
      snackbar: false,     
      message:'',
      from:null,
      to:null,
      menu1:null,
      menu2:null,
      snackbar_color:'success', 
      closedDays:null,
      editedItem:{from:"",to:"",active:1,reason:"",htmlMessage:"",lunch:1,dinner:1},
      dialog_edit:false,
      dialog_delete:false,
      dialog_closedDayException:false,
      dialog_instruction:false,
      closedPeriods:[],
      headers_closedPeriods: [
          { text: 'Dal',       value: 'from',         align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Al',        value: 'to',           align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Motivo',    value: 'reason',       align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Messaggio', value: 'htmlMessage',  align: 'center',  sortable: false, class:'text-lg-button' },
          //{ text: 'Active',    value: 'active',       align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Pranzo',    value: 'lunch',       align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Cena',      value: 'dinner',       align: 'center',  sortable: false, class:'text-lg-button' },
          { text: 'Azione',    value: 'actions',      align: 'center',  sortable: false, class:'text-lg-button' },
      ],
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        //[{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image"],
      ],         
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
    assignedTable(newValue)
    {
      console.log(794,newValue)
      //this.assignedTables.push(newValue);
      console.log(796,newValue,this.assignedTables)
      this.assignTables(newValue);
    }
  },
  methods:
  {
    editItem(f)
    {
      this.editedItem=f?f:{...this.emptyEditedItem};
      console.log(214,f,this.editedItem)
      this.dialog_edit=true;
    },
    deleteItem(i)
    {
      this.editedItem=i;
      console.log(359,i,this.editedItem)
      this.dialog_delete=true;
    },
    async saveItem(a)
    {
        console.log(239,this.editedItem);
        this.loading_update=true;
        console.log(241,this.form);
        var action='saveItem';
        if(a=='delete')
        {
          action='deleteItem';
          this.editedItem.erase=1
        }
        else
        {
          console.log(504, this.editedItem.range)
          var dRange=this.editedItem.range;//.split(',');
          this.editedItem.from=dRange[0]
          this.editedItem.to=dRange[1]
        }
        //var action=a=='delete'?'deleteItem':'saveItem';
        let payload={"action":action,"table":"closedPeriods","payload":this.editedItem};
        console.log(253,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        this.dialog_delete=false;
        console.log(256,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.getData()
            this.$root.$emit('refreshCalendar',null);
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
    },    
    async saveItems()
    {
        this.loading_update=true;
        console.log(255,this.form);
        let payload={"action":"saveItem","table":"ClosedPeriods","payload":JSON.stringify(this.closedPeriods)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.getData();
            this.$root.$emit('refreshCalendar',null);
        }   
    },     
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"ClosedPeriods_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.closedPeriods=res.data.payloads.closedPeriods;
                    this.closedPeriods_hash=JSON.stringify(this.closedPeriods);  
                    console.log(315,this.closedPeriods)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>
<style>
  .v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td, .row-height-36
  {
    height: 34px !important;
  }
  #quill-container{height:200px!important}
</style>